import { createAction } from '@reduxjs/toolkit';
import { WidgetPresence } from 'lib-shared-legacy-types';

const prefix = 'widget';

export const widgetActions = {
  setPresence: createAction<{ presence: WidgetPresence }>(
    `${prefix}/setPresence`,
  ),
};
